/**
 * CartAddedItem component
 * @returns <CartAddedItem />
 */
import Button from "./Button";
import { formatPrice } from "../scripts/helpers/formatPrice";
import { CounterCart } from "./Counter";

import {
    useEditProductMutation,
    useDeleteProductMutation,
} from "../redux/apiSlice";

const CartAddedItem = ({ item, canEdit }) => {
    const [editProduct] = useEditProductMutation();
    const [deleteProduct] = useDeleteProductMutation();

    const addHandler = (id, quantity) => {
        editProduct({
            item_id: id,
            quantity: quantity + 1,
        });
    };

    const decreaseHandler = (id, quantity) => {
        if (item.quantity > 1) {
            editProduct({
                item_id: id,
                quantity: quantity - 1,
            });
        }
    };

    const removeHandler = (id) => {
        deleteProduct({ item_id: id });
    };

    return (
        <div
            className={`cart__added-item ${
                item.type === "maintenance" && canEdit ? "--mantencion" : ""
            }`}
        >
            <div className="cart__added-item__content">
                <img
                    className="cart__added-item__image"
                    src={item.image}
                    alt=""
                />

                <div className="cart__added-item__title-and-description">
                    <img
                        className="type"
                        src={`/static/website/images/icon-${item.type}.svg`}
                        alt=""
                    />

                    <div className="container">
                        <h4 className="cart__added-item__title">
                            {item.type === "maintenance" && item.extra_info
                                ? `Servicio de mantención - ${
                                      JSON.parse(item.extra_info).version
                                  }`
                                : item.title}
                        </h4>
                        <p className="cart__added-item__description">
                            {item.type === "maintenance" && item.extra_info
                                ? JSON.parse(item.extra_info).mantencion
                                : item.extra_info}
                        </p>

                        {canEdit && (
                            <Button
                                text="Eliminar"
                                tag="link"
                                hasIcon={false}
                                onClick={() => removeHandler(item.id)}
                            />
                        )}
                    </div>
                </div>
            </div>

            <div className="cart__added-item__counter-and-price">
                {item.type !== "maintenance" && canEdit && (
                    <CounterCart
                        initial={item.quantity}
                        onAdd={() => addHandler(item.id, item.quantity)}
                        onDecrease={() =>
                            decreaseHandler(item.id, item.quantity)
                        }
                    />
                )}

                <p className="cart__added-item__price">
                    <span>
                        {item.currency === "USD" ? "U$S" : "$"}{" "}
                        {formatPrice(item.totalPrice) ||
                            formatPrice(item.price)}
                    </span>
                </p>
            </div>
        </div>
    );
};

export default CartAddedItem;
